import {LOAD_DATA, START, SUCCESS, STORE, FAIL} from "../../../constants";

const defaultFilters = {
  tag: '',
  subTag: '',
  type: '',
  category: '',
  department: '',
  sort: '',
  search: '',
  page: '',
  rootPath: '',
  combine: '',
};

export default (filters = defaultFilters, action) => {
  const {type, response} = action;

  switch (type) {
    case STORE + LOAD_DATA + START:
      return {...filters, loading: true, loadded: false};

    case STORE + LOAD_DATA + SUCCESS:
      return {...response.filters, loading: false, loadded: true};

    case STORE + LOAD_DATA + FAIL:
      return {...filters, loading: false, loadded: false};
  }

  return filters;
};
